// @flow
import type { StateType } from '../reducers';
import type { DeliveryResourceType } from './reducer';
import { deliveryStatusFormatter } from './lib/formatter';
import { hiddenDeliveryResourcesSelector } from '../yourOrders/reducer';

export const deliveryResourcesSelector = (
  state: StateType,
  withoutCancelled?: boolean
): Array<DeliveryResourceType> => {
  const hiddenDeliveryResources = hiddenDeliveryResourcesSelector(state);
  return state.deliveryResources
    .filter(resource => {
      const isDeliveryResourceShowable = !hiddenDeliveryResources.includes(resource.ouid);
      if (withoutCancelled) {
        return isDeliveryResourceShowable && resource.status !== 'CANCELLED';
      }
      return isDeliveryResourceShowable;
    })
    .map(resource => ({
      ...resource,
      status: deliveryStatusFormatter(resource.status),
    }));
};

export const deliveryResourcesLinkedWithActivableSubscriptionSelector = (
  state: StateType,
  withoutCancelled?: boolean
): Array<DeliveryResourceType> =>
  deliveryResourcesSelector(state, withoutCancelled).filter(
    deliveryResource => deliveryResource.isLinkedWithActivableSubscription
  );
